import { useSyncExternalStore } from 'react';

const SESSION_KEY = 'userId';

type Listener = () => void;

const listeners = new Set<Listener>();

const notifyAll = (): void => {
  listeners.forEach((listener) => listener());
};

const onStorage = (event: StorageEvent): void => {
  if (event.key === null || event.key === SESSION_KEY) notifyAll();
};

const subscribe = (listener: Listener): (() => void) => {
  listeners.add(listener);
  if (listeners.size === 1) window.addEventListener('storage', onStorage);
  return () => {
    listeners.delete(listener);
    if (listeners.size === 0) window.removeEventListener('storage', onStorage);
  };
};

export const isLocalSessionOpen = (): boolean => {
  try {
    return Boolean(window.localStorage.getItem(SESSION_KEY));
  } catch {
    return false;
  }
};

export const notifyLocalSessionChanged = (): void => notifyAll();

export const useHasLocalSession = (): boolean => useSyncExternalStore(subscribe, isLocalSessionOpen, isLocalSessionOpen);
